<template>
  <PageWrapper has-filters :isLoading="isLoading">
    <template #title>
      لیست درس های خریداری شده {{ userFullName ? userFullName : "" }}
    </template>
    <template
      #titleBtn
      v-if="canAddLesson && $can('AddLessonToUserArray', 'Order')"
    >
      <BButton variant="success" @click="renderAddLessonToUserModal">
        افزودن درس
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        inputLabel="عنوان درس"
        inputPlaceholder="درس اول مقدماتی"
        :inputValue="lessonsFilter.lessonTitle"
        v-model="lessonsFilter.lessonTitle"
        @enter="setPageNumberAndGetAllOrders"
      ></SearchInput>
      <SearchInput
        inputLabel="توضیحات تراکنش"
        inputPlaceholder="بابت خرید درس"
        :inputValue="lessonsFilter.description"
        v-model="lessonsFilter.description"
        @enter="setPageNumberAndGetAllOrders"
      ></SearchInput>
      <CustomDatePicker
        class="w-24 filters-width"
        inputId="boughtDate"
        @getSelectedDate="setCreateDateFilter"
        inputLabel="تاریخ خرید"
        inputPlaceholder="تاریخ خرید"
      ></CustomDatePicker>
    </template>
    <CustomTable
      v-if="lessonsList"
      :pageNumber="lessonsFilter.pageNumber"
      :count="lessonsFilter.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="lessonsList"
      @changePage="changePage"
    >
      <template #lessonTitle="data">
        <b-link :to="`/independent-lessons/${data.item.lessonId}`">
          {{ data.item.lessonTitle }}
        </b-link>
      </template>
      <template #createDate="data">
        {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
        -
        {{
          new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        }}
      </template>
      <template #actions="data">
        <BButton
          variant="transparent"
          size="sm"
          @click="renderDeleteConfirmationModal(data.item)"
        >
          <feather-icon size="20" icon="Trash2Icon" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <AddLessonToUserModal
      :externalUserId="userIdFilter"
      @updateLessons="updateLessonsList"
    ></AddLessonToUserModal>
    <LessonDeleteModalConfirmation
      :lessonTitle="computedTempLessonTitle"
      @removeLesson="sendLessonRemoveRequest"
    ></LessonDeleteModalConfirmation>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.setTableColumnsIfCanAddLessonChanged();
    this.lessonsFilter.userId = this.userIdFilter;
    this.getAllUserBoughtLessonsList();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllUserBoughtLessonsList();
      },
    },
    canAddLesson: {
      handler(val) {
        this.setTableColumnsIfCanAddLessonChanged();
      },
    },
  },
  emits: ["updateOrdersList"],
  props: {
    userIdFilter: {
      type: [String, Number],
      required: true,
    },
    userFullName: {
      type: [String],
      required: false,
    },
    canAddLesson: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lessonsFilter: {
        pageNumber: 1,
        count: 10,
        id: null,
        userId: null,
        fullName: null,
        mobile: null,
        email: null,
        createDate: null,
        description: null,
        lessonId: null,
        lessonTitle: null,
      },
      isLoading: false,
      totalCount: null,
      lessonsList: null,
      tempLesson: null,
      myTableColumns: [
        {
          key: "lessonTitle",
          label: "عنوان درس",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت تراکنش",
        },
        {
          key: "description",
          label: "توضیحات تراکنش",
        },
      ],
    };
  },
  methods: {
    renderDeleteConfirmationModal(lesson) {
      this.tempLesson = JSON.parse(JSON.stringify(lesson));
      this.$bvModal.show("remove-lesson-from-user");
    },
    setCreateDateFilter(date) {
      if (date) {
        this.lessonsFilter.createDate = new Date(date).toISOString();
      } else {
        this.lessonsFilter.createDate = null;
      }
    },
    setTableColumnsIfCanAddLessonChanged() {
      if (this.canAddLesson) {
        this.myTableColumns.splice(3, 0, {
          key: "actions",
          label: "عملیات",
        });
      } else {
        this.myTableColumns.splice(3, 1);
      }
    },
    changePage(pageNumber) {
      this.lessonsFilter.pageNumber = pageNumber;
      this.getAllUserBoughtLessonsList();
    },
    updateLessonsList() {
      this.$emit("updateOrdersList");
      this.getAllUserBoughtLessonsList();
    },
    renderAddLessonToUserModal() {
      if (this.renderAddLessonToUserModal) {
        this.$bvModal.show("add-lesson-to-user");
      }
    },
    clearDateFilter() {
      this.lessonsFilter.createDate = null;
    },
    setPageNumberAndGetAllOrders() {
      this.lessonsFilter.pageNumber = 1;
      this.getAllUserBoughtLessonsList();
    },
    createJalaliDate(date) {
      if (date) {
        const myCustomDate = new Date(date).toLocaleDateString("fa-IR");
        return `${myCustomDate}`;
      } else {
        return null;
      }
    },
    async sendLessonRemoveRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let removeLessonFromUser = new RemoveLessonFromUser(_this);
        removeLessonFromUser.setRequestParam({
          userId: _this.userIdFilter,
          lessonId: _this.tempLesson.lessonId,
        });
        await removeLessonFromUser.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "درس با موفقیت حذف شد!",
              },
            });
            _this.$bvModal.hide("remove-lesson-from-user");
            _this.tempLesson = null;
            _this.getAllUserBoughtLessonsList();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllUserBoughtLessonsList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUserBoughtLessons = new GetAllUserBoughtLessons(_this);
        getAllUserBoughtLessons.setRequestParamDataObj(_this.lessonsFilter);
        await getAllUserBoughtLessons.fetch((res) => {
          _this.lessonsList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.lessonsFilter.pageNumber;
    },
    computedTempLessonTitle() {
      if (this.tempLesson && this.tempLesson.lessonTitle) {
        return this.tempLesson.lessonTitle;
      }
      return null;
    },
  },
  components: {
    PageWrapper,
    BButton,
    BLink,
    AddLessonToUserModal,
    SearchInput,
    CustomDatePicker,
    LessonDeleteModalConfirmation,
    CustomTable,
  },
};
import { GetAllUserBoughtLessons } from "@/libs/Api/UserBoughtLesson";
import { RemoveLessonFromUser } from "@/libs/Api/Order";
import AddLessonToUserModal from "@/views/components/Lessons/AddLessonToUserModal.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import LessonDeleteModalConfirmation from "@/views/components/UserBoughtLessons/LessonDeleteModalConfirmation.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BButton, BLink } from "bootstrap-vue";
</script>
